import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';

const SubscriptionFrame = () => {
  return (
    <div className="subscription-frame">
      <p>Upgrade your Subscription to access this feature.</p>
      <Link to={ROUTES.UPGRADE}>
        View Subscription Plans
      </Link>
    </div>
  );
};

export default SubscriptionFrame;
